import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"

interface ReturnedType {
    status: "success"
}

export const deleteStaffUser = createAsyncThunk<ReturnedType, number, AppThunkProps>(
    "staff/remove",
    async (id, {signal}) => {
        return api.delete<ReturnedType>(`/user/${id}`, {signal})
    }
)
